import moment from "moment"

const demandStatusFinder = (demandData) => {
    const startDate = moment(demandData?.startDate).startOf("day");
    const todaysDate = moment().startOf("day");

    const deadlineReturnString = (value, type) => {
        if (type === "left") {
            return value > 1 ? `${value} days left` : `${value} day left`;
        } else {
            return value > 1 ? `${value} days overdue` : `${value} day overdue`;
        }
    };

    if (todaysDate <= startDate) {
        const deadLineValue = startDate.diff(todaysDate, "days");

        if (deadLineValue > 10)
            return {
                deadline: deadlineReturnString(deadLineValue, "left"),
                deadLineStatus: "default",
            };
        else if (deadLineValue <= 10 && deadLineValue >= 5) {
            return {
                deadline: deadlineReturnString(deadLineValue, "left"),
                deadLineStatus: "due",
            };
        }
        else if (deadLineValue >= 0 && deadLineValue < 5) {
            return {
                deadline: deadlineReturnString(deadLineValue, "left"),
                deadLineStatus: "overDue",
            };
        }

        return {};
    } else if (todaysDate > startDate) {
        const overDueValue = todaysDate.diff(startDate, "days");
        if (overDueValue >= 1) {
            return {
                deadline: deadlineReturnString(overDueValue, "over"),
                deadLineStatus: "overDue",
            };
        }
    }
}

export default demandStatusFinder